import React, { useEffect, useRef, useState } from 'react';
import { listHoldings } from './../../actions/zerodhaActions';
import { useDispatch, useSelector } from 'react-redux';
import { getForms } from '../../actions/formActions';
import Listing from '../../components/Common/Listing/Listing';
import _ from "lodash"
import { Line } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';

ChartJS.register(
    CategoryScale,
    LinearScale,
    Title,
    Tooltip,
    Legend
);

const ZerodhaHoldings = (props) => {
    const listFormKey = "ZERODHA_holdings_list_form";
    const dispatch = useDispatch();
    const zerodhaState = useSelector((state) => state.zerodha);
    const formState = useSelector((state) => state.forms);
    const { formJson = {} } = formState;
    const listingJson = formJson[listFormKey] || {};
    const { holdings = {} } = zerodhaState;
    const { holdingsChartData = {} } = zerodhaState;
    const [fetchingList, setFetchingList] = useState(_.isEmpty(holdings));
    const hasFetchedListRef = useRef(false);
    const { headers = [], data: listData = [], meta = {} } = holdings;
    const { chartValues = [] } = holdingsChartData;

    useEffect(() => {
        if (!_.isEmpty(holdings) && fetchingList) {
            setFetchingList(false);
        }
    }, [holdings])

    useEffect(() => {
        if (_.isEmpty(listingJson)) return;
        if (hasFetchedListRef.current) return;
        hasFetchedListRef.current = true;
        listApi();
    }, [listingJson]);

    useEffect(() => {
        dispatch(getForms(listFormKey));
    }, []);

    const listApi = () => {
        setFetchingList(true);
        dispatch(listHoldings({}, listFormKey));
    }

    const getHoldingsChart = (_chartData, title = 'Holdings % Change From Start Date') => {
        const getRandomColor = () => {
            const r = Math.floor(Math.random() * 255);
            const g = Math.floor(Math.random() * 255);
            const b = Math.floor(Math.random() * 255);
            return {
                border: `rgb(${r}, ${g}, ${b})`,
                background: `rgba(${r}, ${g}, ${b}, 0.5)`
            };
        };

        const line_options = {
            responsive: true,
            plugins: {
                legend: {
                    position: 'top',
                },
                title: {
                    display: true,
                    text: title,
                },
            },
        };
        const [firstData = {}] = _chartData;
        const { data = [] } = firstData;
        const line_labels = data.map(({ date }) => date);
        const line_data = {
            labels: line_labels,
            datasets:
                _chartData.map(datum => {
                    const { name = '', data = [] } = datum;
                    const color = getRandomColor();
                    return {
                        label: name,
                        data: data.map(d => d.value),
                        borderColor: color.border,
                        backgroundColor: color.background,
                    }
                })
        };

        return <div className="col-md-12">
            <Line options={line_options} data={line_data} />
        </div>
    }

    return (
        <div className="row">
            {chartValues.length > 0 ? getHoldingsChart(chartValues) : ''}
            <div className="col-md-12">
                <Listing
                    headers={headers}
                    data={listData}
                    onSearch={listApi}
                    meta={meta}
                    fetchingList={fetchingList}
                />
            </div>
        </div>

    )
}

export default ZerodhaHoldings;
